/*
eslint class-methods-use-this: ["error", {
  "exceptMethods": [
    calculateWalletCharge
  ]
}]
*/
/* global logger */
const moment = require('moment');
const { slaChargeType } = require('pando-constants');

class ArrivalBreach {
  calculateWalletCharge(data, prevTransporterId = null) {
    let amount = 0;
    const { order, sla: slaCharge, clientConfig: config } = data;

    const DaySeconds = 24 * 60 * 60;
    const slaBreachedAt = order.sla_job_data && order.sla_job_data.sla_breach_at;
    let requiredDate;
    const placementReliability = config.placement_reliability;
    if (config && config.auto_switch_transporter_on_non_placement
      && config.auto_switch_transporter_on_non_placement.auto_switch_on_sla_breach) {
      requiredDate = new Date();
    } else if (order && order.timestamps && order.timestamps.arrived_at) {
      requiredDate = order.timestamps.arrived_at;
    } else {
      requiredDate = new Date();
    }
    const difference = moment(requiredDate)
      .diff(moment(slaBreachedAt), 'seconds');
    const isArrivalBreachAtNull = order.timestamps && order.timestamps.arrival_breached_at === null;
    if (isArrivalBreachAtNull) {
      return 0;
    // return 0 if arrival_at timestamp is edited and made before arrival_breach_timestamp PAN-9334
    }

    if (slaCharge && slaCharge.length) {
      const days = Math.floor(difference / DaySeconds) + 1;
      const previousTransporter = order.previous_transporters[order.previous_transporters.length - 1];
      if (slaCharge[0].arrival_delay_cost) {
        if (placementReliability && placementReliability.enabled &&
          placementReliability.penalty_charges_type === slaChargeType.PERCENTAGE) {
          amount = slaCharge[0].arrival_delay_cost / 100;
          if (previousTransporter) {
            if (order.transporter_id.toString() === prevTransporterId.toString()) {
              amount *= previousTransporter.assigned_transporter.freight_rate;
            } else {
              amount *= previousTransporter.previous_transporter.freight_rate;
            }
          } else {
            amount *= order.destinations[0].contract.freight_charges;
          }
        } else if (days && days > 0) {
          amount = days * slaCharge[0].arrival_delay_cost;
        }
      }
    } else {
      logger.error(`Wallet entry not created for the ${order.order_no} since slaCharge is empty`);
    }

    return amount;
  }
}

module.exports = ArrivalBreach;
